__turbopack_context__.v({
  "className": "fontheading_5e5dd137-module__1YoewG__className",
  "variable": "fontheading_5e5dd137-module__1YoewG__variable",
});
